// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ytCKD","content":"Card_content__j-miA"};